<template lang="pug">
  .consultation--company-details
    v-layout.location-header.align-center.py-3
      v-flex.text-right.sm12
        v-btn.mr-3(
          v-if="company.update_company_data_possible"
          color="primary"
          :loading="loading === 'update-company'"
          @click="onUpdateCompany"
        ) Unternehmensdaten aktualisieren

        v-btn(color="primary" :loading="loading === 'start'" @click="onStart") {{ isNewStep ? 'Beratung starten' : 'Beratung fortsetzen' }}

    v-form(ref="form-consultation" lazy-validation @submit.prevent="() => {}")
      v-expansion-panels(v-model="panel" accordion flat tile multiple)
        v-expansion-panel
          v-expansion-panel-header.category-header Unternehmen
          v-expansion-panel-content(eager)
            v-row.mt-6
              v-col.pb-0(cols="12" sm="6"): v-text-field(
                v-model="company.company_name"
                label="Firmenname"
                outlined
                readonly
              )

              v-col.pb-0(cols="12" sm="6"): v-text-field(
                v-model="company.company_website"
                label="Firmenwebseite"
                outlined
                readonly
              )

              v-col.pb-0(cols="12" sm="6" md="3"): v-checkbox(
                v-model="company.ewe_granted"
                label="Ewe erteilt"
                outlined
                hide-details
                readonly
              )

              v-col.pb-0(cols="12" sm="6" md="3"): n-date-picker(
                ref="ewe_granted_at"
                v-model="company.ewe_granted_at"
                label="EwE erteilt am"
                format="YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
                disabled
              )

            h4.primary--text.mt-6 Ansprechpartner

            template(v-for="(contact, index) in company.contacts")
              v-divider.mt-4.mb-2(v-if="index > 0" :key="`hr-${ index }`")

              v-row.align-center.mt-1(v-if="!contact.deleted" :key="index")
                v-col.pb-0(cols="12" sm="6" md="3"): v-select(
                  v-model="contact.salutation"
                  label="Anrede"
                  outlined
                  readonly
                  :items="salutations"
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.academic_title"
                  label="Titel"
                  outlined
                  readonly
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-select(
                  v-model="contact.role"
                  label="Rolle"
                  outlined
                  readonly
                  :items="roles"
                )

                v-col.d-none.d-md-block.pb-0(md="3")

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.forename"
                  label="Vorname"
                  outlined
                  readonly
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.lastname"
                  label="Nachname"
                  outlined
                  readonly
                )

                v-col.pb-0(cols="12" sm="6" md="3"): n-date-picker(
                  v-model="contact.birthday"
                  label="Geburtsdatum"
                  format="YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
                  readonly
                )

                v-col.d-none.d-md-block.pb-0(md="3")

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.email"
                  label="Email"
                  outlined
                  readonly
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.telefone_nr"
                  label="Telefon"
                  outlined
                  readonly
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="contact.mobile_nr"
                  label="Mobiltelefon"
                  outlined
                  readonly
                )

            v-row: v-col.pt-0(cols="12" sm="6" md="6")
              v-textarea.mt-3(
                v-model="company.contact_data"
                label="Absender (Druckansicht)"
                outlined
                @change="onUpdateContactData"
              )

        template(v-for="(location, locIndex) in company.locations")
          v-expansion-panel.mt-3(v-if="!location.deleted" :key="locIndex")
            v-expansion-panel-header.category-header.pr-4: v-layout.align-center
              span Standort {{ location.name ? `(${ location.name })` : '' }}

            v-expansion-panel-content(eager)
              v-row.align-center.mt-6
                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="location.name"
                  label="Name oder Bezeichnung des Standortes"
                  outlined
                  readonly
                )

                v-col.pt-0.pt-sm-3(cols="12" sm="6" md="3"): v-checkbox.mt-0.mt-sm-4.mb-4(
                  v-model="location.has_buildings"
                  label="Befinden sich Gebäude auf dem Standort?"
                  hide-details
                  readonly
                )

                v-col.pt-0.pt-sm-3(cols="12" sm="6" md="3"): v-checkbox.mt-0.mt-sm-4.mb-4(
                  v-model="location.is_main_location"
                  label="Handelt es sich um den Hauptstandort?"
                  hide-details
                  readonly
                  @change="(v) => onSelectLocation(locIndex, v)"
                )

              h4.primary--text.mt-6 Adresse des Standortes

              v-row.align-center.mt-1
                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="location.street"
                  label="Straße"
                  outlined
                  readonly
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="location.plz"
                  label="PLZ"
                  outlined
                  readonly
                )

                v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                  v-model="location.city"
                  label="Ort"
                  outlined
                  readonly
                )

                v-col.d-none.d-md-block.pb-0(md="3")

                v-col.pb-0(cols="12" sm="6" md="3"): v-combobox(
                  v-model="location.country"
                  label="Land"
                  outlined
                  :items="countries"
                  readonly
                )

              h4.primary--text.mt-6 Gebäude

              template(v-for="(building, bldIndex) in location.buildings")
                v-divider.mt-4.mb-2(v-if="bldIndex > 0" :key="`building-hr-${ bldIndex }`")

                v-row.align-center.mt-1(v-if="!building.deleted" :key="`building-${ bldIndex }`")
                  v-col.pb-0(cols="12" sm="6" md="3"): v-text-field(
                    v-model="building.name"
                    label="Name oder Bezeichnung des Gebäudes"
                    outlined
                    readonly
                  )

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'

@Component({
  mixins: [
    FormMixin
  ],

  watch: {
    id () {
      this.loadDetails()
    }
  }
})
export default class DetailsData extends Vue {
  @Prop({ type: [ Number, String ], default: 0 }) id

  panel = [0, 1]
  company = {
    locations: [],
  }
  loading = null

  get isNewStep () {
    return !this.company.step || this.company.step === 'new'
  }

  created () {
    if (this.id) {
      this.loadDetails()
    }
  }

  loadDetails () {
    return this.$axios
      .get(Urls.Consultation(this.id))
      .then(res => {
        this.company = res.data
        this.$emit('loaded', res.data)
        this.$nextTick(() => {
          this.isEditied = 0
        })
      })
  }

  onStart () {
    if (!this.isNewStep) {
      return this.$emit('next', true)
    }

    const params = {
      with_rules: this.isDebugMode > 0
    }

    this.loading = 'start'
    this.$axios
      .post(`${ Urls.Consultation(this.id) }start/`, params)
      .then(() => {
        this.$emit('next', false)
        return this.loadDetails()
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
      .finally(() => {
        this.$nextTick(() => {
          this.loading = null
        })
      })
  }

  onUpdateContactData (v) {
    this.$axios
      .post(`${ Urls.Consultation(this.id) }update_contact_data/`, {
        contact_data: v
      })
      .then(() => {
        this.$emit('loaded', {
          ...this.company,
          contact_data: v
        })
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
  }

  onUpdateCompany () {
    this.loading = 'update-company'

    this.$axios
      .post(`${ Urls.Consultation(this.id) }update_company_data/`)
      .then(res => {
        this.$router.push({
          name: 'consultation-edit',
          params: {
            id: res.data.id
          }
        })
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
      .finally(() => {
        this.loading = null
      })
  }
}
</script>
